import { ProjectPhaseStatus } from "../../../../models";
import { Column, InformationBox, Row } from "../../../../widget";

interface EditDatesPanelBannerProps {
  phaseStatus?: ProjectPhaseStatus;
  phaseEndDate?: Date;
}
export const EditDatesPanelBanner = ({
  phaseStatus,
  phaseEndDate,
}: EditDatesPanelBannerProps): JSX.Element | undefined => {
  // Completed phase banner
  if (phaseStatus === ProjectPhaseStatus.COMPLETED) {
    return (
      <Row spacingV="xl">
        <Column span={12}>
          <InformationBox variant="success" direction="row">
            <p className="body1">
              <b>You have completed this phase</b>
            </p>
          </InformationBox>
        </Column>
      </Row>
    );
  }

  // Incomplete phase but date is in the past
  if (phaseEndDate && phaseEndDate < new Date()) {
    return (
      <Row spacingV="xl">
        <Column span={12}>
          <InformationBox variant="info">
            <div className="ProjectTasksBoardBannerOverrunningContainer">
              <div className="ProjectTasksBoardBannerOverrunningContent">
                <p className="body1">
                  <b>Your project is now overrunning the current phase range</b>
                </p>
                <p className="body1">
                  The current date is beyond the end date for this phase. To keep your timeline accurate, edit the phase
                  and task deadlines.
                </p>
              </div>
            </div>
          </InformationBox>
        </Column>
      </Row>
    );
  }

  return undefined;
};
